import http from '../http'
import {ROLE_LIST} from '../../services/endpoints'

export function getRoleList() {
    return http.request({
      url:ROLE_LIST,
      method:'get',
    })
  }